import { render, staticRenderFns } from "./FolderDelete.vue?vue&type=template&id=1efeffc7"
import script from "./FolderDelete.vue?vue&type=script&lang=ts"
export * from "./FolderDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports